import { RouteConfig } from 'vue-router'
import { aiAgentsContestRoutes } from '../constants/agency/aiEmployeePromo'
import { requireAuth } from '../auth'

const AiAgentsContest = () =>
  import(
    /* webpackChunkName: "ai-agents-contest" */ '@/apps/conversations/settings/aiAgentsContest.vue'
  )

export const aiAgentsContest: RouteConfig[] = [
  {
    path: '/ai-agents-contest',
    name: aiAgentsContestRoutes.default,
    component: AiAgentsContest,
    beforeEnter: requireAuth,
  }
]
